import { useCallback } from "react";
import { useAtom, useSetAtom } from "jotai";
import { Button } from "@zapier/design-system";
import {
  floatingToolbarActiveButtonAtom,
  sidebarOpenNodeIdAtom,
} from "@zapier/canvas-state";
import styles from "./NotesButton.module.css";

type Props = {
  id: string;
  hasNotes: boolean;
  isViewOnlyMode: boolean;
};

export function NotesButton({ id, hasNotes, isViewOnlyMode }: Props) {
  const [activeButton, setActiveButton] = useAtom(
    floatingToolbarActiveButtonAtom,
  );
  const setSidebarOpenNodeId = useSetAtom(sidebarOpenNodeIdAtom);

  const onNotesButtonClick = useCallback(() => {
    const isAlreadyOpen = "note" === activeButton;
    setActiveButton(isAlreadyOpen ? null : "note");
    setSidebarOpenNodeId(isAlreadyOpen ? "" : id);
  }, [activeButton, id, setActiveButton, setSidebarOpenNodeId]);

  if (!hasNotes) {
    return null;
  }

  return (
    <div className={styles.notesButton}>
      <Button
        color="tertiary"
        size="compact"
        iconBefore="fileFilled"
        onClick={onNotesButtonClick}
        disabled={isViewOnlyMode}
      >
        Notes
      </Button>
    </div>
  );
}
